export const hasPerm = (perm) => {
  try {
    const perms = JSON.parse(localStorage.getItem("tienda_permisos") || "[]");
    return Array.isArray(perms) && perms.includes(perm);
  } catch {
    return false;
  }
};